<template>
  <HvhModal :value="true" title="Upload Document" :isLoading="isLoading || isLoadingCategories" @input="$emit('close')">
    <template v-slot>
      <v-form @input="formValid = $event" ref="form">
        <div class="col-12 pl-1 mb-2">
          <div class="hvh-flex align-center mb-2">
            <HvhUploadFile v-model="formData.file" accept="*" ref="uploadFile" />
            <span class="ml-1" @click="pickFile">{{ formData.file?.name || formData.fileName || 'Choose File...' }}</span>
          </div>

          <!-- <v-file-input class="mb-2" label="File input" v-model="formData.file" :rules="requiredRules" prepend-icon="mdi-camera" disabled /> -->
          <div class="v-text-field__details" v-if="showFileError">
            <div class="v-messages theme--light error--text">
              <div class="v-messages__wrapper"><div class="v-messages__message">File is required</div></div>
            </div>
          </div>
        </div>

        <v-select class="col-12 pt-0" v-model="formData.categoryId" :items="categories" item-value="id" item-text="name" label="Category" :rules="requiredRules" />
        <v-text-field class="col-12 pt-0" label="Description" v-model="formData.description" :rules="requiredRules" v-if="checkOtherCategory(formData.categoryId)"/>
        <div class="col-12 pt-0" v-if="!checkOtherCategory(formData.categoryId)">
        <HvhDatePicker label="Expiration Date" v-model="formData.expirationDate" :rules="showExpirationDateForCategory(formData.categoryId)?requiredRules:[]"/>
        </div>
        <div class="col-12 pt-0" v-if="showExpirationDateForCategory(formData.categoryId)">
        <slot name="notify-section" :formData="formData"></slot>
        </div>
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: wasValidated && !formValid }" @click="saveData">Save</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import cloneDeep from 'clone-deep';
import HvhModal from '../common/modal/HvhModal.vue';
import HvhUploadFile from '../common/uploadFile/HvhUploadFile.vue';
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';

export default {
  components: { HvhModal, HvhUploadFile },
  props: ['value', 'isLoading',],
  data() {
    var requiredRules = [v => !!v || v === false || 'Field is required'];
    const categoryNames = new Set(['Master Service Agreement (MSA)', 'Non Disclosure Agreement (NDA)', 'RAM License']);
    return {
      formData: cloneDeep(this.value),
      formValid: true,
      wasValidated: false,
      categories: [],
      isLoadingCategories: false,
      requiredRules,
      categoryNames,
    };
  },
  computed: {
    showFileError() {
      return this.wasValidated && !this.formData.file;
    },
  },
  methods: {
    pickFile() {
      this.$refs.uploadFile.$refs.input.click();
    },
    saveData() {
      this.wasValidated = true;
      if (!this.$refs.form.validate()||this.showFileError) return;
      this.$emit('input', this.formData);
    },
    getCategories() {
      this.isLoadingCategories = true;
      axios.get(`/api/ITM/DocumentCategories`)
        .then(({ data }) => this.categories = data)
        .catch(errorDebug)
        .then(() => this.isLoadingCategories = false);
    },
    showExpirationDateForCategory(id){
      return this.categories.some(t => this.categoryNames.has(t.name) && t.id === id);
    },
    checkOtherCategory(id)
    {
      return id===this.categories.find(t=>t.name==='Other')?.id;
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMUploadDocument'] = this;
    this.getCategories();
  },
}
</script>
